import { Phone, Mail, Globe, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#1E293B] text-white py-10" data-testid="footer-section">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo & About */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              {/* Logo image - larger for better visibility */}
              <img 
                src="https://customer-assets.emergentagent.com/job_fa466eb8-6701-4b93-b151-474047be8b48/artifacts/9i72k6q6_W%26O-01.png"
                alt="Care Leavers Inner Circle"
                className="h-24 w-auto object-contain"
              />
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-4 max-w-sm">
              India's first careleaver-led non-profit enabling young adults 
              leaving institutional care to transition into independent, dignified lives.
            </p>
            <div className="flex items-center gap-2 text-[#4FB6A6] font-medium text-xs">
              <span>Care-leaver–led</span>
              <span className="text-slate-500">·</span>
              <span>Institution-ready</span>
              <span className="text-slate-500">·</span>
              <span>Partner-validated</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Quick Links</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li>
                <a href="https://www.clicforum.org/about-us/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="https://www.clicforum.org/careleavers/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  For Careleavers
                </a>
              </li>
              <li>
                <a href="https://www.clicforum.org/donors/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  CSR & Donors
                </a>
              </li>
              <li>
                <a href="https://www.clicforum.org/partners-and-associated-programs/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  Partners
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-sm mb-3">Contact</h4>
            <ul className="space-y-2 text-slate-400 text-sm">
              <li className="flex items-center gap-2">
                <Phone className="w-3 h-3 text-[#4FB6A6]" />
                <a href="tel:+918686368555" className="hover:text-white transition-colors">
                  +91 86863 68555
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-3 h-3 text-[#4FB6A6]" />
                <a href="mailto:partnership@clicforum.org" className="hover:text-white transition-colors">
                  partnership@clicforum.org
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Globe className="w-3 h-3 text-[#4FB6A6]" />
                <a href="https://www.clicforum.org" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">
                  www.clicforum.org
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-3 h-3 text-[#4FB6A6] mt-0.5" />
                <span>MIIC, Jaipur, Rajasthan</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-slate-500 text-xs">
            © {new Date().getFullYear()} CLIC - Careleavers Inner Circle. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-slate-500 text-xs">
              Registered Non-Profit | 12A · 80G · CSR-1
            </p>
            <a 
              href="/admin/login" 
              className="text-slate-600 hover:text-slate-400 text-[10px] transition-colors"
              data-testid="footer-admin-link"
            >
              Admin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
